import { useTranslation } from 'react-i18next'

import { DotsThreeCircleVerticalIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { ButtonMenu, IconButton, Switch, Text } from '@reveni-io/reveni-ui'

import { integrationStatusLabels } from './constants'
import { canToggleIntegration, getMenuItems } from './helpers'
import * as Styles from './styles'

const ConnectedActions = ({ integration, onToggle, onUninstall, onEdit, disabled }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const statusLabel = integrationStatusLabels[integration.status]

  return (
    <Styles.ConnectedActionsContainer>
      {statusLabel && (
        <Styles.StatusLabel>
          <Text type="bodySRegular">{t(statusLabel)}</Text>
        </Styles.StatusLabel>
      )}
      {canToggleIntegration(integration) && (
        <Switch
          checked={integration?.enabled}
          onChange={e => onToggle(integration, e.target.checked)}
          disabled={disabled}
        />
      )}
      {!disabled && (
        <ButtonMenu
          renderButton={onClick => (
            <IconButton
              onClick={onClick}
              variant="text"
              icon={<DotsThreeCircleVerticalIcon size={22} weight="light" data-testid="integration-method-menu" />}
            />
          )}
          menuItems={getMenuItems({ t, onEdit, onUninstall, integration, theme }).map(item => ({
            itemKey: item.id,
            label: (
              <Styles.MenuItem>
                <item.icon color={item.iconColor} />
                {item.label}
              </Styles.MenuItem>
            ),
            onClick: item.onClick,
          }))}
        />
      )}
    </Styles.ConnectedActionsContainer>
  )
}

export default ConnectedActions
